import React from "react";
import { ExportButton } from "components/buttons";
import { exportKPISummary, KPISummaryExportRequest } from "api";
import { validateExportParams } from "utils";

export const ExportExcelButton = ({ query }: { query: KPISummaryExportRequest }) => (
    <ExportButton
        exportFunction={exportKPISummary}
        exportParams={query}
        exportText="Export Excel"
        exportingText="Exporting Excel..."
        successMessage="Excel exported successfully."
        isZipFile={false}
        exportTitle="kpi-summary-table"
        onBeforeExport={validateExportParams}
        sx={{
            borderRadius: "8px",
            width: '204px',
            height: '36px',
            fontWeight: 500
        }}
    />
);